<template>
  <div>
    <div class="p-y-4 b b-cl">
      <div class="unt-n itm CASE">
        <div class="h-8 rlt b b-fg">
          <div class="unt u-8 abs .s .t">
            <i class="material-icons">search</i>
          </div>
          <input
            v-model="search"
            :placeholder="$t('search_placeholder')"
            class="fld fld-n p-x-8 -r-m u-f"
          />
          <transition name="fade">
            <div class="unt u-8 abs .e .t" v-if="search.length" @click="search=''">
              <i class="material-icons">close</i>
            </div>
          </transition>
        </div>
        <div class="m-e-3 b b-c">
          <div style="min-width: 40px;" class="b m-x-3 -r-c -o-h a-c unt h-7 c-grn-t" @click="orderBy = 'recovered'">
            <i class="u-f material-icons c-grn c-0-t" v-if="orderBy === 'recovered'">arrow_upward</i>
            <i class="u-f material-icons" v-if="orderBy !== 'recovered'">arrow_downward</i>
          </div>
          <div style="min-width: 40px;" class="b m-x-3 -r-c -o-h a-c unt h-7 c-orng-t" @click="orderBy = 'cases'">
            <i class="u-f material-icons c-orng c-0-t" v-if="orderBy === 'cases'">arrow_upward</i>
            <i class="u-f material-icons" v-if="orderBy !== 'cases'">arrow_downward</i>
          </div>
          <div style="min-width: 40px;" class="b m-x-3 -r-c -o-h a-c unt h-7 c-rd-t" @click="orderBy = 'deaths'">
            <i class="u-f material-icons c-rd c-0-t" v-if="orderBy === 'deaths'">arrow_upward</i>
            <i class="u-f material-icons" v-if="orderBy !== 'deaths'">arrow_downward</i>
          </div>
        </div>
      </div>
      <div
        :class="'unt itm Case' + (countryData.country.code === selectedCountry.country.code?' c19':'')"
        v-for="countryData in getSelectedCountries(orderBy, search)"
        :key="countryData.index"
        @click="selectCountry(countryData)"
      >
        <div class="b b-fs b-c">
          <img
            :src="getCountryFlag(countryData)"
            class="u-7 p-3"
          />
          <i class="material-icons" v-if="countryData.deaths > 300">
            <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" style="fill: currentColor;" class="h-6" > <path d="m361 247c0-24.8125-20.1875-45-45-45s-45 20.1875-45 45 20.1875 45 45 45 45-20.1875 45-45zm-45 15c-8.269531 0-15-6.730469-15-15s6.730469-15 15-15 15 6.730469 15 15-6.730469 15-15 15zm0 0" /> <path d="m196 202c-24.8125 0-45 20.1875-45 45s20.1875 45 45 45 45-20.1875 45-45-20.1875-45-45-45zm0 60c-8.269531 0-15-6.730469-15-15s6.730469-15 15-15 15 6.730469 15 15-6.730469 15-15 15zm0 0" /> <path d="m457 362c-8.820312 0-17.429688 2.148438-25.175781 6.191406l-39.320313-39.324218c18.34375-26.90625 28.496094-59.046876 28.496094-92.867188 0-23.878906-5.105469-46.585938-14.269531-67.09375l25.09375-25.097656c7.746093 4.042968 16.355469 6.191406 25.175781 6.191406 30.324219 0 55-24.671875 55-55 0-25.722656-17.746094-47.375-41.640625-53.359375-5.984375-23.894531-27.636719-41.640625-53.359375-41.640625-30.328125 0-55 24.671875-55 55 0 8.820312 2.148438 17.429688 6.191406 25.175781l-19.4375 19.433594c-26.449218-18.042969-58.390625-28.609375-92.753906-28.609375s-66.304688 10.566406-92.753906 28.609375l-19.4375-19.433594c4.042968-7.746093 6.191406-16.355469 6.191406-25.175781 0-30.328125-24.671875-55-55-55-25.722656 0-47.375 17.746094-53.359375 41.640625-23.894531 5.984375-41.640625 27.636719-41.640625 53.359375 0 30.328125 24.671875 55 55 55 8.820312 0 17.429688-2.148438 25.175781-6.191406l25.09375 25.097656c-9.164062 20.507812-14.269531 43.214844-14.269531 67.09375 0 33.820312 10.152344 65.960938 28.496094 92.867188l-39.320313 39.324218c-7.746093-4.042968-16.355469-6.191406-25.175781-6.191406-30.328125 0-55 24.671875-55 55 0 25.722656 17.746094 47.375 41.640625 53.359375 5.984375 23.894531 27.636719 41.640625 53.359375 41.640625 30.328125 0 55-24.671875 55-55 0-8.820312-2.148438-17.429688-6.191406-25.175781l17.191406-17.1875v1.363281c0 8.285156 6.714844 15 15 15h160c8.285156 0 15-6.714844 15-15v-1.363281l17.191406 17.1875c-4.042968 7.746093-6.191406 16.355469-6.191406 25.175781 0 30.328125 24.671875 55 55 55 25.722656 0 47.375-17.746094 53.359375-41.640625 23.894531-5.984375 41.640625-27.636719 41.640625-53.359375 0-30.328125-24.671875-55-55-55zm-58.773438-269.4375c5.683594-5.679688 5.878907-14.828125.445313-20.75-4.304687-4.683594-6.671875-10.65625-6.671875-16.8125 0-13.785156 11.214844-25 25-25s25 11.214844 25 25c0 8.285156 6.714844 15 15 15 13.785156 0 25 11.214844 25 25s-11.214844 25-25 25c-6.15625 0-12.128906-2.367188-16.8125-6.671875-5.921875-5.433594-15.070312-5.238281-20.75.445313l-28.042969 28.039062c-5.757812-8.257812-12.253906-15.964844-19.386719-23.027344zm-305.664062 21.210938c-5.679688-5.683594-14.828125-5.878907-20.75-.445313-4.683594 4.304687-10.65625 6.671875-16.8125 6.671875-13.785156 0-25-11.214844-25-25s11.214844-25 25-25c8.285156 0 15-6.714844 15-15 0-13.785156 11.214844-25 25-25s25 11.214844 25 25c0 6.15625-2.367188 12.128906-6.671875 16.8125-5.433594 5.921875-5.238281 15.070312.445313 20.75l26.21875 26.222656c-7.136719 7.0625-13.628907 14.769532-19.390626 23.027344zm21.210938 305.664062c-5.683594 5.679688-5.878907 14.828125-.445313 20.75 4.304687 4.683594 6.671875 10.65625 6.671875 16.8125 0 13.785156-11.214844 25-25 25s-25-11.214844-25-25c0-8.285156-6.714844-15-15-15-13.785156 0-25-11.214844-25-25s11.214844-25 25-25c6.15625 0 12.128906 2.367188 16.8125 6.671875 5.921875 5.433594 15.070312 5.238281 20.75-.445313l46.132812-46.128906c6.800782 6.84375 14.25 13.152344 22.304688 18.820313v1.292969zm207.226562-18.4375h-20v-15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v15h-30v-15c0-8.285156-6.714844-15-15-15s-15 6.714844-15 15v15h-20v-38.101562c0-5.144532-2.636719-9.933594-6.988281-12.683594-39.457031-24.925782-63.011719-67.621094-63.011719-114.214844 0-74.4375 60.5625-135 135-135s135 60.5625 135 135c0 46.59375-23.554688 89.289062-63.011719 114.21875-4.351562 2.746094-6.988281 7.535156-6.988281 12.679688zm136 41c-8.285156 0-15 6.714844-15 15 0 13.785156-11.214844 25-25 25s-25-11.214844-25-25c0-6.15625 2.367188-12.128906 6.671875-16.8125 5.433594-5.921875 5.238281-15.070312-.445313-20.75l-47.226562-47.226562v-1.292969c8.054688-5.667969 15.503906-11.976563 22.304688-18.824219l46.132812 46.132812c5.679688 5.679688 14.828125 5.875 20.75.445313 4.683594-4.304687 10.65625-6.671875 16.8125-6.671875 13.785156 0 25 11.214844 25 25s-11.214844 25-25 25zm0 0" /> </svg>
          </i>
          <i class="material-icons" v-else-if="countryData.deaths > 100">warning</i>
          <i class="material-icons" v-else-if="countryData.deaths > 20">mood_bad</i>
          <i class="material-icons" v-else>mood</i>
          <span class="...n">{{ $t('countries')[countryData.country.code.toUpperCase()] }}</span>
        </div>
        <div class="ln m-x-5 o-7"></div>
        <div class="m-s-a m-e-3 b b-c">
          <div class="unt h-7 c-grn-t" style="min-width: 36px;">
            <div
              class="unt h-6 p-n m-x-3 bdg bdg-s b-c -r-c c-grn c-20-t font-en p-x-2"
              style="min-width: 40px;font-size: 13px !important;font-weight: bold;;"
            >{{ convert(countryData.recovered) }}</div>
          </div>
          <div class="unt h-7 c-orng-t" style="min-width: 36px;">
            <div
              class="unt h-6 p-n m-x-3 bdg bdg-s b-c -r-c c-orng c-20-t font-en p-x-2"
              style="min-width: 40px;font-size: 13px !important;font-weight: bold;;"
            >{{ convert(countryData.cases) }}</div>
          </div>
          <div class="unt h-7 c-rd-t" style="min-width: 36px;">
            <div
              class="unt h-6 p-n m-x-3 bdg bdg-s b-c -r-c c-rd c-20-t font-en p-x-2"
              style="min-width: 40px;font-size: 13px !important;font-weight: bold;"
            >{{ convert(countryData.deaths) }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ListWidget',
  computed: {
    ...mapState(['selectedCountry']),
    ...mapGetters(['getSelectedCountries', 'getSelectedCountriesTotal', 'getCountryFlag'])
  },
  data () {
    return {
      search: '',
      orderBy: 'cases'
    }
  },
  methods: {
    convert (number) {
      if (number < 1000) {
        return number
      } else if (number >= 1000 && number < 1000000) {
        var toFix = number < 10000 ? 1 : 0
        return (number / 1000).toFixed(toFix) * 1 + 'K'
      } else {
        return (number / 1000000).toFixed(1) * 1 + 'M'
      }
    },
    selectCountry (countryData) {
      this.$router.push({ query: { ...this.$route.query, country: countryData.country.code } })
    },
    sortCountries (countries, orderBy = 'cases') {
      return new Promise((resolve, reject) => {
        resolve(
          countries.sort((a, b) => {
            if (a[orderBy] < b[orderBy]) {
              return -1
            }
            if (a[orderBy] > b[orderBy]) {
              return 1
            }
            return 0
          })
        )
      })
    }
  }
}
</script>
